import {
    NatGetCondominiumList,
    SearchCondition,
    SearchConditionPageInfo,
    SearchConditions,
    SearchSortOrder
} from './NatGetCondominiumList'
import {NatGetCondominium} from './NatGetCondominium'
import {NatGetCondominiumAuthed} from './NatGetCondominiumAuthed'
import {NatPostCondominium, NatPostCondominiumParams} from './NatPostCondominium'
import {NatPutCondominium, NatPutCondominiumParams} from './NatPutCondominium'
import {NatDeleteCondominium} from './NatDeleteCondominium'
import {NatGetCondominiumFacilityReserveIntroductory} from './NatGetCondominiumFacilityReserveIntroductory'
import {
    NatPutCondominiumFacilityReserveIntroductoryParams,
    NatPutCondominiumFacilityReserveIntroductoryResponse
} from './NatPutCondominiumFacilityReserveIntroductory'

import Http from '../../../../network/Http'
import {ContentType} from '../../../../network/Constants';
import {NatZipCode} from './NatZipCode';
import {NatPostCondominiumListByResidentResponse} from './NatPostCondominiumListByResident'

export default class NatCondominiumRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // 郵便番号に対する住所取得
    async getZipCode(firstPart: string, lastPart: string): Promise<NatZipCode> {
        return await this.http.get(`https://madefor.github.io/postal-code-api/api/v1/${firstPart}/${lastPart}.json`);
    }

    // 物件一覧取得
    async getCondominiumList(
        searchRequest:
            SearchCondition &
            SearchConditionPageInfo &
            SearchSortOrder): Promise<NatGetCondominiumList> {
        return await this.http.post(`/api/admin/condominiumList`,
            searchRequest,
            ContentType.JSON);
    }

    // 物件取得
    async getCondominium(condominiumCd: string): Promise<NatGetCondominium> {
        return await this.http.get(`/api/admin/condominium/${condominiumCd}`);
    }

    // 物件一覧取得（ログイン済）
    async getCondominiumAuthed(searchCondition: string): Promise<NatGetCondominiumAuthed> {
        return await this.http.get(`/api/resident/condominium/authed?${searchCondition}`);
    }

    // 物件登録
    async postCondominium(postCondominiumParams: NatPostCondominiumParams): Promise<NatPostCondominium> {
        return await this.http.post(
            `/api/admin/condominium`,
            postCondominiumParams,
            ContentType.JSON,
        );
    }

    // 物件更新
    async putCondominium(putCondominiumParams: NatPutCondominiumParams): Promise<NatPutCondominium> {
        return await this.http.put('/api/admin/condominium', putCondominiumParams)

    }

    // 物件削除
    async deleteCondominium(condominiumCd: string): Promise<NatDeleteCondominium> {
        return await this.http.delete(`/api/admin/condominium/delete/${condominiumCd}`)

    }

    // 物件施設予約紹介文取得
    async getCondominiumFacilityReserveIntroductory(condominiumCd: string):
        Promise<NatGetCondominiumFacilityReserveIntroductory> {
        return await this.http.get(`/api/admin/condominium/facilityReserveIntroductory/${condominiumCd}`);
    }

    // 物件施設予約紹介文更新
    async putCondominiumFacilityReserveIntroductory(
        putCondominiumFacilityReserveIntroductoryParams: NatPutCondominiumFacilityReserveIntroductoryParams):
        Promise<NatPutCondominiumFacilityReserveIntroductoryResponse> {
        return await this.http.put(
            `/api/admin/condominium/facilityReserveIntroductory/${putCondominiumFacilityReserveIntroductoryParams.condominiumCd}`
            , putCondominiumFacilityReserveIntroductoryParams)
    }

    // 物件一覧取得（居住者）
    async getCondominiumListByResident(zipCode: string): Promise<NatPostCondominiumListByResidentResponse> {
        return await this.http.post(
            `/api/resident/condominiumList`,
            {zipCode},
            ContentType.JSON,
        )
    }
}
